import PropTypes from "prop-types"
import React, { Component } from "react"
import { BlockContextConsumer } from "../ContextProviders"
import BroadcastItem from "../broadcast/BroadcastItem"

class PropertyValue extends Component {
    static propTypes = {
        name: PropTypes.string.isRequired,
        deep: PropTypes.bool,
    }

    renderChildren(broadcast) {
        if (!broadcast) return null
        return this.props.children(this.props.context.propertyStore.get(broadcast.id))
    }
    render() {
        if (!this.props.name && !this.props.id) {
            return null
        }

        return (
            <BroadcastItem name={this.props.name} id={this.props.id} deep={this.props.deep}>
                {value => this.renderChildren(value)}
            </BroadcastItem>
        )
    }
}

export default function PropertyValueInContext(props) {
    return (
        <BlockContextConsumer>
            {context => <PropertyValue {...props} context={context} />}
        </BlockContextConsumer>
    )
}



// WEBPACK FOOTER //
// ./src/features/editor/properties/PropertyValue.js